export default "__VITE_ASSET__jFwS8cvn__"